import { Outlet } from 'react-router';

import { ToastContainer } from '@perpay-web/components/base/ToastProvider/ToastContainer';
import BorrowerHeaderContainer from '@perpay-web/fintech/components/containers/BorrowerHeaderContainer';
import GlobalUserVerificationModalContainer from '@perpay-web/fintech/components/containers/GlobalUserVerificationModalContainer';
import NotificationsContainer from '@perpay-web/fintech/components/containers/NotificationsContainer';
import { nativeUpgradeNotificationSetIsModalOpen } from '@perpay-web/fintech/hooks/useNativeUpgradeNotificationModalContext';
import { paths } from '@perpay-web/fintech/props/appPaths';
import store from '@perpay-web/fintech/settings/configureStore';
import { shouldShowNativeUpgradeNotification } from '@perpay-web/fintech/utils/nativeUpgradeNotificationUtils';
import { useFullBottomNavRender } from '@perpay-web/hooks/useFullBottomNavContext';
import { useMount } from '@perpay-web/hooks/useMount';
import { useSupportTool } from '@perpay-web/hooks/useSupportTool';
import { useTrackLocationChange } from '@perpay-web/hooks/useTrackLocationChange';
import { getClassName } from '@perpay-web/utils/domUtils';
import {
    pathIsInReactStorefront,
    setReactStorefrontHistory,
} from '@perpay-web/utils/routeUtils';

import styles from './App.scss';

const App = ({ onMount }) => {
    useMount(onMount);
    const renderedBottomNav = useFullBottomNavRender();

    useTrackLocationChange((routeState) => {
        setReactStorefrontHistory(routeState);
        const { location } = routeState;

        if (
            pathIsInReactStorefront(location) ||
            [paths.login.path, paths.logout.path].includes(location.pathname)
        )
            return null;

        if (shouldShowNativeUpgradeNotification()) {
            return store.dispatch(
                nativeUpgradeNotificationSetIsModalOpen(true),
            );
        }
        return null;
    });
    useSupportTool();

    return (
        <div
            className={getClassName(
                styles.app,
                renderedBottomNav ? styles['has-footer'] : '',
            )}
        >
            <NotificationsContainer />
            <ToastContainer />
            <BorrowerHeaderContainer />
            <div className={styles.app__container}>
                <Outlet />
            </div>
            {renderedBottomNav}
            <GlobalUserVerificationModalContainer />
        </div>
    );
};

export default App;
